'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgArrowNextCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M8 2c3.312 0 6 2.688 6 6s-2.688 6-6 6-6-2.688-6-6 2.688-6 6-6zm0 1.286A4.72 4.72 0 003.286 8 4.72 4.72 0 008 12.714 4.72 4.72 0 0012.714 8 4.72 4.72 0 008 3.286zm1.881 2.716l1.422 1.638c.086.1.127.23.126.36.001.13-.04.26-.126.36L9.88 9.998a.392.392 0 01-.609 0 .553.553 0 010-.703l.72-.83h-4.99c-.238 0-.43-.223-.43-.497s.192-.496.43-.496h4.935l-.665-.768a.552.552 0 010-.702.392.392 0 01.61 0z", fill: "currentColor" }))));
}

module.exports = SvgArrowNextCircle;
//# sourceMappingURL=ArrowNextCircle.js.map
